import { render, staticRenderFns } from "./UserBit.vue?vue&type=template&id=6a67e40c&scoped=true&"
import script from "./UserBit.vue?vue&type=script&lang=js&"
export * from "./UserBit.vue?vue&type=script&lang=js&"
import style0 from "./UserBit.vue?vue&type=style&index=0&id=6a67e40c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a67e40c",
  null
  
)

export default component.exports